<template>
  <div class="mb-3">
    <div class="subheader mb-2">Categories (Unselect to exclude)</div>

    <div class="list-group">
      <a
        v-if="showSelectAll"
        class="list-group-item list-group-item-action cj-toggle"
        :title="selectAllTitle"
        href="#"
        @click.capture.prevent="toggleSelectAll"
      >
        <div class="cover">&nbsp;</div>

        <div class="under d-flex align-items-center">
          <input
            ref="selectAllCheckbox"
            type="checkbox"
            class="form-check-input me-3 flex-shrink-0"
            :checked="selectAllChecked"
            tabindex="-1"
            @click.prevent.stop
          />

          <div class="d-flex flex-column">
            <span>Select all categories</span>
          </div>
        </div>
      </a>

      <a
        class="list-group-item list-group-item-action cj-toggle"
        v-for="category in categories"
        :key="`cat-selector-${category.categoryid}`"
        :title="`Click to exclude`"
        href="#"
        :disabled="excludeSites.includes(category.siteid)"
        @click.capture.prevent="toggle(category)"
      >
        <div class="cover">&nbsp;</div>

        <div class="under d-flex align-items-center">
          <input
            type="checkbox"
            :class="[
              'form-check-input',
              'me-3',
              'flex-shrink-0',
              excludeSites.includes(category.siteid) ? 'disabled' : '',
              excludeSites.includes(category.siteid) ? 'indeterminate' : '',
            ]"
            :checked="!value.includes(category.categoryid)"
            :disabled="excludeSites.includes(category.siteid)"
          />

          <div class="d-flex flex-column">
            <small class="text-muted">{{ siteName(category.siteid) }}</small>
            <span>{{ category.path }}</span>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<style lang="scss">
.cj-toggle {
  .cover {
    position: absolute;
    top: 0;
    left: 0;

    z-index: 1000;

    min-width: 100%;
    min-height: 100%;

    background: transparent;
  }

  .under {
    position: relative;
    top: 0;
    left: 0;

    z-index: 1;

    width: 100%;
    height: 100%;
  }
}
</style>

<script>
export default {
  name: "CategorySelect",
  props: {
    excludeSites: Array,
    categories: Array,
    value: Array,
  },
  computed: {
    selectableCategories() {
      const cats = this.categories || [];
      const excluded = this.excludeSites || [];
      return cats.filter((c) => !excluded.includes(c.siteid));
    },
    showSelectAll() {
      return this.selectableCategories.length > 0;
    },
    selectAllChecked() {
      const selectable = this.selectableCategories;
      return (
        selectable.length > 0 &&
        selectable.every((c) => !this.value.includes(c.categoryid))
      );
    },
    selectAllIndeterminate() {
      const selectable = this.selectableCategories;
      const n = selectable.length;
      if (n === 0) return false;
      const excludedCount = selectable.filter((c) =>
        this.value.includes(c.categoryid)
      ).length;
      return excludedCount > 0 && excludedCount < n;
    },
    selectAllTitle() {
      return this.selectAllChecked
        ? "Click to exclude all categories"
        : "Click to include all categories";
    },
  },
  watch: {
    excludeSites: function () {
      this.categories.forEach((c) => {
        if (
          !this.value.includes(c.categoryid) &&
          this.excludeSites.includes(c.siteid)
        ) {
          this.value.push(c.categoryid);
        } else if (
          this.value.includes(c.categoryid) &&
          !this.excludeSites.includes(c.siteid)
        ) {
          this.value.splice(this.value.indexOf(c.categoryid), 1);
        }
      });
    },
    selectAllIndeterminate: "syncSelectAllIndeterminate",
    selectAllChecked: "syncSelectAllIndeterminate",
    showSelectAll: "syncSelectAllIndeterminate",
  },
  mounted() {
    this.syncSelectAllIndeterminate();
  },
  methods: {
    syncSelectAllIndeterminate() {
      this.$nextTick(() => {
        const el = this.$refs.selectAllCheckbox;
        if (el) {
          el.indeterminate = this.selectAllIndeterminate;
        }
      });
    },
    toggleSelectAll() {
      const selectable = this.selectableCategories;
      if (selectable.length === 0) return;

      const allIncluded = selectable.every(
        (c) => !this.value.includes(c.categoryid)
      );

      if (allIncluded) {
        selectable.forEach((c) => {
          if (!this.value.includes(c.categoryid)) {
            this.value.push(c.categoryid);
          }
        });
      } else {
        selectable.forEach((c) => {
          const idx = this.value.indexOf(c.categoryid);
          if (idx !== -1) {
            this.value.splice(idx, 1);
          }
        });
      }
    },
    siteName(siteId) {
      let sites = this.$auth.activeCompany?.sites || [];
      let site = sites.filter((s) => s.siteID == siteId);

      if (site.length > 0) {
        return site[0].siteName;
      } else {
        return "";
      }
    },
    toggle(category) {
      if (this.excludeSites.includes(category.siteid)) {
        // no-op
        return;
      }

      if (this.value.includes(category.categoryid)) {
        this.value.splice(this.value.indexOf(category.categoryid), 1);
      } else {
        this.value.push(category.categoryid);
      }
    },
  },
};
</script>
